import React from 'react';
export function TruthSection() {
  return <section className="w-full bg-brand-wine py-16 md:py-24 px-4 text-white" data-id="element-175">
      <div className="max-w-3xl mx-auto text-center" data-id="element-176">
        <h2 className="font-serif text-3xl md:text-5xl font-bold mb-12 text-brand-gold leading-tight" data-id="element-177">
          La verdad que puede cambiar tu vida
        </h2>

        <div className="space-y-10 text-lg md:text-2xl max-w-2xl mx-auto" data-id="element-178">
          <div className="space-y-2" data-id="element-179">
            <p className="text-white/60 line-through decoration-red-500/50 decoration-2" data-id="element-180">
              No necesitas perseguir amor.
            </p>
            <p className="font-bold text-white" data-id="element-181">
              Necesitas recordar quién eres.
            </p>
          </div>

          <div className="space-y-2" data-id="element-182">
            <p className="text-white/60 line-through decoration-red-500/50 decoration-2" data-id="element-183">
              No necesitas que alguien te elija.
            </p>
            <p className="font-bold text-white" data-id="element-184">
              Necesitas volver a elegirte tú.
            </p>
          </div>

          <div className="space-y-2" data-id="element-185">
            <p className="text-white/60 line-through decoration-red-500/50 decoration-2" data-id="element-186">
              No necesitas seguir soportando situaciones que te rompen por
              dentro.
            </p>
            <p className="font-bold text-white" data-id="element-187">
              Necesitas reconocer tu valor.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-white/20" data-id="element-188">
          <p className="text-xl md:text-3xl font-serif italic text-brand-cream" data-id="element-189">
            Y precisamente para eso fue creado MERECES MÁS.
          </p>
        </div>
      </div>
    </section>;
}